import {
  composeErrorMessage,
  extractClassicErrorMessage,
  getActivationPageUrl,
  getSignInUrl,
  makeErrorWithContext,
} from 'utils'
import { getAuthRootUrl, getClassicApiEndpoint } from '../../constants/api'
import { FastTrackPersonDetails } from '../../types/global'
import { createRegLog } from 'modules/reg-logger'

export const PERSON_DETAILS_ENDPOINT =
  getClassicApiEndpoint() + 'v2/User/GetRegistrationDetails?registrationToken='
export const PERSON_DETAILS_FOR_CURRENT_USER_ENDPOINT =
  getClassicApiEndpoint() + 'v2/User/GetRegistrationDetailsForCurrentuser'

const registrationApi = {
  getBasicPersonDetails: async (regToken: string): Promise<FastTrackPersonDetails> => {
    if (regToken) {
      const res = await fetch(PERSON_DETAILS_ENDPOINT + regToken)

      if (res.ok) {
        const personDetails = await res.json()
        return personDetails
      } else {
        const classicErrorMessage = await extractClassicErrorMessage(res)
        const message = composeErrorMessage([
          'Failed to fetch fast-track person details',
          classicErrorMessage,
        ])
        const error = makeErrorWithContext(res, { message })

        throw error
      }
    } else {
      throw new Error('No registration token provided')
    }
  },
  getForbiddenRegistrationMessage: async (countryCode: string): Promise<string | null> => {
    if (countryCode) {
      const RESIDENCE_COUNTRY_MESSAGE_CONTROLLER_ENDPOINT = `/api/CountryMessage?countryCode=${countryCode}`
      const res = await fetch(RESIDENCE_COUNTRY_MESSAGE_CONTROLLER_ENDPOINT)

      if (res.ok) {
        return ((await res.json()) as { message: string }).message
      } else if (res.status === 404) {
        return null
      } else {
        const classicErrorMessage = await extractClassicErrorMessage(res)
        const message = composeErrorMessage([
          'Failed to fetch residence country message',
          classicErrorMessage,
        ])
        const error = makeErrorWithContext(res, { message })

        throw error
      }
    } else {
      throw new Error('No country code provided')
    }
  },
  redirectToSignUp: (token: string, options: { enableLogging: boolean }) => {
    const { enableLogging } = options
    const toUrl = `${getAuthRootUrl()}/account/fasttrack?registrationToken=${token}`
    if (enableLogging) createRegLog('redirectToSignUp', { to: toUrl })
    window.location.assign(toUrl)
  },
  redirectToSignIn: (options: { returnUrl?: string; enableLogging: boolean }) => {
    const { returnUrl, enableLogging } = options
    const toUrl = getSignInUrl(returnUrl)
    if (enableLogging) createRegLog('redirectToSignIn', { to: toUrl })
    window.location.assign(toUrl)
  },
  redirectToActivation: (options: { enableLogging: boolean }) => {
    const { enableLogging } = options
    const toUrl = getActivationPageUrl()
    if (enableLogging) createRegLog('redirectPendingUser', { to: toUrl })
    window.location.assign(toUrl)
  },
}

export default registrationApi
